import JobHistory from '@/models/job-history'

export function eventIsUnapproval(event: JobHistory): boolean {
  return event.fieldsChanged.some(
    (field) => field.columnName === 'approved_by_user_sid' && field.newValue === null,
  )
}
